"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var makeStyles_1 = require("@material-ui/core/styles/makeStyles");
var GUTTER = 2;
var buttonWithIconStyles = makeStyles_1.default(function (theme) { return ({
    root: {
        paddingTop: 0,
        paddingBottom: 0,
        paddingRight: function (props) { return props.iconSize + 10; },
        height: function (props) { return props.iconSize; },
        position: 'relative',
        alignContent: 'center',
        display: 'flex',
        '&:hover span:last-child': {
            opacity: 0.96,
        },
    },
    icon: {
        display: 'block',
        position: 'absolute',
        top: GUTTER,
        right: GUTTER,
        height: function (props) { return props.iconSize - GUTTER * 2; },
        width: function (props) { return props.iconSize - GUTTER * 2; },
        background: theme.palette.primary.contrastText,
        borderRadius: '30px',
    },
}); }, { name: 'Checkout_ButtonWithIcon' });
exports.default = buttonWithIconStyles;
